interface SortableItem {
  sortNumber?: number | null;
}

export function sortItems<T extends SortableItem>(arrayToSort: T[]): T[] {
  arrayToSort.sort((a: T, b: T) => {
    const aNotSet = a.sortNumber === undefined || a.sortNumber === 0 || a.sortNumber === null;
    const bNotSet = b.sortNumber === undefined || b.sortNumber === 0 || b.sortNumber === null;

    if (aNotSet && bNotSet) return 0;
    if (aNotSet) return 1;
    if (bNotSet) return -1;

    return (a.sortNumber || 0) - (b.sortNumber || 0);
  });

  return arrayToSort;
}

export function validateEntities<T>(entities: T[], property: keyof T): boolean {
  const seen = new Set<string>();
  return entities.every((entity) => {
    const value = (entity[property] as unknown as string)?.trim();
    if (!value) {
      return false;
    }
    const lower = value.toLowerCase();
    if (seen.has(lower)) {
      return false;
    }
    seen.add(lower);
    return true;
  });
}
